import * as React from "react";
import { Gapped, Input, Select } from "react-ui";

import { Caption, Row } from "../../FiasFnsManualEditor.styles";
import { getHouseTypeLongName } from "../../../../FiasInput/Utils/Convertations/House/House";
import { getAddBuildingItems, SelectType } from "../FiasFnsManualEditorUtils";

interface BuildingProps {
    type: string | undefined;
    number: string | undefined;
    onTypeChange: (next: string) => void;
    onNumberChange: (next: string) => void;
}

export function Building({ type, number, onTypeChange, onNumberChange }: BuildingProps): JSX.Element | null {
    const add2BuildingItems: SelectType = getAddBuildingItems(type);

    return (
        <Row>
            <Caption />
            <Gapped>
                <Select<string | undefined, string>
                    width={80}
                    value={getHouseTypeLongName(type) || type || undefined}
                    onValueChange={next => onTypeChange(next ?? "")}
                    placeholder={"Тип"}
                    data-tid={"BuildingType"}
                    items={add2BuildingItems}
                />
                <Input
                    width={80}
                    maxLength={255}
                    value={number ?? ""}
                    placeholder={"Номер"}
                    data-tid={"BuildingNum"}
                    onValueChange={next => onNumberChange(next)}
                />
            </Gapped>
        </Row>
    );
}
